import { createState } from "state-pool"

//The current environment of the Blind Insight application
export const CurrentEnvironment = createState("")

// The current user object if we have one
export const CurrentUser = createState({})

// Hash of organization.id to the organization object
export const Organizations = createState({})
export const CurrentOrgId = createState("")
export const CurrentOrg = createState(null)

// Hash of dataset.id to the dataset object
export const Datasets = createState({})

// Hash of schema.id to the schema
export const Schemas = createState({})

// Hash of schema.id to the number of records in that schema
export const SchemaRecordCounts = createState({})

// Hash of dataset.id to a list of schema.id
export const DatasetSchemas = createState({})

// Hash of the schema.id to the schema with hashed field keys
export const HashedSchemas = createState({})

// The current status of the upload job
export const JobStatus = createState(null)

// The current name of the file being uploaded
export const FileName = createState("")

// The current File specific error
export const FileError = createState(null)

// The current API error
export const ApiError = createState(null)

// The current upload progress
export const UploadProgress = createState(0)

// Upload status enum
export const UploadStatus = {
  NONE: "NONE",
  UPLOADING: "UPLOADING",
  TERMINATED: "TERMINATED",
  COMPLETED: "COMPLETED",
}

// Whether or not an upload is in progress
export const IsUploading = createState(UploadStatus.NONE)

// Track success/failure of each batch in the upload
export const UploadBatchStatus = createState(null)

// Track the current alert index
export const CurrentAlertIndex = createState(0)

// List of all teams and members for a schema
export const SchemaTeams = createState([])

// Object to use as a default import
export function Store(name) {
  const stores = {
    currentUser: CurrentUser,
    organizations: Organizations,
    datasets: Datasets,
    schemas: Schemas,
    datasetSchemas: DatasetSchemas,
    hashedSchemas: HashedSchemas,
    jobStatus: JobStatus,
    fileName: FileName,
    fileError: FileError,
    uploadProgress: UploadProgress,
    isUploading: IsUploading,
    apiError: ApiError,
    uploadBatchStatus: UploadBatchStatus,
  }
  if (!stores[name]) throw new Error(`${name} is not a valid store`)
  return stores[name]
}

// The current limit
export const Limit = createState(25)

// The current offset
export const Offset = createState(0)

// List of active filters
export const CurrentFilters = createState([])

export const Pagination = createState({
  limit: Limit.value,
  offset: Offset.value,
})

// List of alerts to display to the user
export const Alerts = createState([])

// List of alerts that the user has dismissed this browser session
export const DontShowAgainList = createState([])

export default Store
